import { fetch } from '@utils/utils';
import * as T from '@modules/hr-templates/periods/_periodsTypes';

const getPeriodTemplate = ({ addError }) => async (id: string): Promise<T.Period | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/period/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Period = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const createPeriodTemplate = async (data: T.Period): Promise<T.Period | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/period/${data.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(data)
    });

    const json: T.Period = await response.json();

    return json;
  } catch (err) {
    return {};
  }
};

const getAllPeriodTemplates = async (): Promise<T.Period[] | boolean> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/period/`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Period[] = await response.json();

    return json;
  } catch (err) {
    return false;
  }
};

export { getPeriodTemplate, getAllPeriodTemplates, createPeriodTemplate };



// WEBPACK FOOTER //
// ./src/modules/hr-templates/periods/_periodsActions.ts